export const SigninActionTypes = {
    PASSWORD_SHOW_HIDE: 'PASSWORD_SHOW_HIDE',
    PASSWORD_CURRENT_PASS: 'PASSWORD_CURRENT_PASS',
    PASSWORD_NEW_PASS: 'PASSWORD_NEW_PASS',
    PASSWORD_CONFIRM_PASS: 'PASSWORD_CONFIRM_PASS',

    SIGNUP_SLIDE_INCREASE: 'SIGNUP_SLIDE_INCREASE',
    SIGNUP_SLIDE_DECREASE: 'SIGNUP_SLIDE_DECREASE'
}